/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export type InitializeConfigArgs = { cosigners: Array<Address> };

export type InitializeConfigArgsArgs = InitializeConfigArgs;

export function getInitializeConfigArgsEncoder(): Encoder<InitializeConfigArgsArgs> {
  return getStructEncoder([
    ['cosigners', getArrayEncoder(getAddressEncoder())],
  ]);
}

export function getInitializeConfigArgsDecoder(): Decoder<InitializeConfigArgs> {
  return getStructDecoder([
    ['cosigners', getArrayDecoder(getAddressDecoder())],
  ]);
}

export function getInitializeConfigArgsCodec(): Codec<
  InitializeConfigArgsArgs,
  InitializeConfigArgs
> {
  return combineCodec(
    getInitializeConfigArgsEncoder(),
    getInitializeConfigArgsDecoder(),
  );
}
